<template>
    <div class="login-wrapper">
        <div class="login-top">
            欢迎登录车智管
        </div>
        <div class="login-input">
            <input type="text" v-model="submitForm.tenantCode" class="weui-input" placeholder="请输入租户编号"/>
        </div>
        <div class="login-input">
            <input type="text" v-model="submitForm.userCode" class="weui-input" placeholder="请输入账号"/>
        </div>
        <div class="login-input">
            <input type="password" v-model="submitForm.userPassword" class="weui-input" placeholder="请输入密码"/>
        </div>
        <!-- <div class="login-forgetPwd">
            登录即代表您已同意<div class="goAgreement" @click="goAgreement">《隐私条款声明》</div>
        </div> -->
        <div class="login-btn">
            <button type="primary" color="#00B38A" @click="doLogin" :disabled="!(submitForm.tenantCode && submitForm.userCode &&submitForm.userPassword)">登录</button>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            submitForm: {
                tenantCode: '',
                userCode: '',
                userPassword: '',
                code: ''
            },
        }
    },
    mounted() {
        this.submitForm.code = this.$route.query.code
    },
    methods: {
        async doLogin() {
            const data = await this.$api.doLogin(this.submitForm)
            if (data.success) {
                this.$router.push({
                    path: '/login/success'
                })
            }
        },
    },
}
</script>
<style lang="scss">
.login-wrapper {
    .login-top {
        margin-top: 100px;
        margin-left: 25px;
        margin-bottom: 32px;
        font-size: 25px;
        color: #333947;
    } 
    .login-input {
        margin: 0 25px 5px;
        padding: 9px 0;
        font-size: 15px;
        border-bottom: 1px solid #EBEBED;
        input {
            width: 100%;
            border: none;
        }
    }
    .login-forgetPwd {
        font-size: 14px;
        padding: 15px 25px;
        color: #aaa;
        .goAgreement {
            color: #169BD6;
            display: inline;
        }
    }
    .login-btn {
        margin-top: 15px;
        padding: 0 25px;
        border: 50px;
        button {
            width: 100%;
            height: 40px;
            background-color: #00B38A;
            border: none;
            color: #fff;
        }
    }
}
</style>